import React, { useState } from "react";
import { SignaturePad } from "../../../../shared/components";

const SendCIAMenu = ({
  // Current Property Details
  currentProp, // { rebate, panelAmount, panel, systemSize, syncPropId }

  // Financing and Proposal Information
  mappedAdders,
  mappedProposals,
  financingLabel,
  ciaButton,

  // Panel Information
  panelAmount,
  originalPanelAmount,

  // Design Preferences
  designObj,
  designDetails,

  // State Management
  nem,
  hoa,
  hoaName,
  hoaPhone,
  includeSqFtAmendment,
  newBuild,
  showError,
  errorMessage,
  sizeChangeNotes,
  checkmark,
  state,

  // Utility and Location Information
  utilityLocation,

  // Callback Functions
  setNem,
  setHoa,
  setHoaName,
  setHoaPhone,
  setIncludeSqFtAmendment,
  adderToggle,
  setNewBuild,
  setDesignObj,
  setDesignDetails,
  setSizeChangeNotes,
  handleInput,
  electronicConsent,
  setElectronicConsent,
}) => {
  const [signed, setSigned] = useState(false);
  return (
    <>
      {currentProp ? (
        <div className="container">
          <div className="row">
            <h3 className="menuFont">Customer Installation Agreement</h3>
          </div>
          <div className="custContainer menu">
            <div className="row">
              <div className="menuBorder"></div>
            </div>
            <div className="row">
              <div className="col">{financingLabel()}</div>
            </div>
            <div className="row">
              <div className="col">
                <div className="savingsText modals doc">
                  Rebate:{" "}
                  {(+currentProp.rebate).toLocaleString(undefined, {
                    style: "currency",
                    currency: "USD",
                  })}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="savingsText modals doc">
                  Panel Amount: {Math.round(currentProp.panelAmount)}{" "}
                  {currentProp.panel}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="savingsText modals doc">
                  System Size: {currentProp.systemSize / 1000}kW
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                {currentProp.syncPropId ? (
                  <>
                    <div className="savingsText modals doc">
                      Proposal ID: {currentProp.syncPropId}
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="row">
              <div className="menuBorder"></div>
            </div>
            <div className="row">
              <div className="col">
                <div className="savingsText modals doc">Incentives:</div>
              </div>
            </div>
            {mappedAdders}
            <div className="row">
              <div className="menuBorder"></div>
            </div>
            <div className="row">
              <div className="col">
                <div className="savingsText modals doc">
                  Select Proposal for CIA
                </div>
                {mappedProposals}
              </div>
            </div>
            <div className="row">
              <div className="menuBorder"></div>
            </div>
            <div className="row">
              <div
                className="row"
                onClick={(e) => {
                  setNem(!nem);
                }}
              >
                <div className="col-sm-1 col-2">
                  <div className={nem ? "checkBox checked" : "checkBox"}>
                    <img src={checkmark}></img>
                  </div>
                </div>
                <div className="col">
                  <div className="qualyText check">Attach NEM to CIA</div>
                </div>
              </div>
              <div
                className="row"
                onClick={(e) => {
                  setIncludeSqFtAmendment(!includeSqFtAmendment);
                }}
              >
                <div className="col-sm-1 col-2">
                  <div className={includeSqFtAmendment ? "checkBox checked" : "checkBox"}>
                    <img src={checkmark}></img>
                  </div>
                </div>
                <div className="col">
                  <div className="qualyText check">Include Square Footage Amendment</div>
                </div>
              </div>
              <div
                className="row"
                onClick={(e) => {
                  setHoa(!hoa);
                  if (hoa) {
                    setHoaName("");
                    setHoaPhone("");
                  }
                }}
              >
                <div className="col-sm-1 col-2">
                  <div className={hoa ? "checkBox checked" : "checkBox"}>
                    <img src={checkmark}></img>
                  </div>
                </div>
                <div className="col">
                  <div className="qualyText check">Customer has an HOA</div>
                </div>
              </div>
              {hoa ? (
                <>
                  <div className="row">
                    <div className="col-6">
                      <input
                        className="custInput qualy moz"
                        value={hoaName}
                        onChange={(e) => setHoaName(e.target.value)}
                        placeholder="Name of HOA"
                      ></input>
                    </div>
                    <div className="col-6">
                      <input
                        className="custInput qualy moz"
                        type="tel"
                        value={hoaPhone}
                        onChange={(e) => handleInput(e, setHoaPhone)}
                        placeholder="Phone number of HOA"
                      ></input>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
              <div
                className="row"
                onClick={(e) => {
                  adderToggle(newBuild, setNewBuild);
                }}
              >
                <div className="col-sm-1 col-2">
                  <div className={newBuild ? "checkBox checked" : "checkBox"}>
                    <img src={checkmark}></img>
                  </div>
                </div>
                <div className="col">
                  <div className="qualyText check">
                    New build or new move in
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="savingsText modals doc">
                  What is the customer's design preference?
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <select
                  className="finInput"
                  onChange={(e) => setDesignObj(e.target.value)}
                >
                  <option style={{ display: "none" }}>
                    {" "}
                    {designObj ? designObj : "Design Preference"}
                  </option>
                  <option value="Match Current Proposal">
                    {" "}
                    Match Current Proposal
                  </option>
                  <option value="No design preference, max production">
                    {" "}
                    No design preference, max production
                  </option>
                  <option value="No solar panels on the front of the home">
                    {" "}
                    No solar panels on the front of the home
                  </option>
                  <option value="Aesthetics are most important">
                    Aesthetics are most important
                  </option>
                </select>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="savingsText modals doc">
                  Design Preference Details (optional)
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <input
                  className="finInput"
                  onChange={(e) => setDesignDetails(e.target.value)}
                  placeholder='ie: "Customer wants a symmetrical layout and is willing to drop panels to achieve that."'
                ></input>
              </div>
            </div>
            {panelAmount !== originalPanelAmount ? (
              <>
                <div className="row">
                  <div className="col">
                    <div className="savingsText modals doc">
                      Reason for{" "}
                      {panelAmount > originalPanelAmount
                        ? "adding"
                        : "removing"}{" "}
                      panels {panelAmount > originalPanelAmount ? "to" : "from"}{" "}
                      original design
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <input
                      className="finInput"
                      onChange={(e) =>
                        setSizeChangeNotes(
                          `${
                            panelAmount > originalPanelAmount
                              ? `Added ${panelAmount - originalPanelAmount}`
                              : `Removed ${originalPanelAmount - panelAmount}`
                          } - ${e.target.value}`
                        )
                      }
                      placeholder="Customer Notes"
                    ></input>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}

            {showError ? (
              <>
                <div className="row justify-content-center">
                  <div className="col" align="center">
                    <div className="errorMessage">{errorMessage}</div>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
            <div className="row">
              <div className="menuBorder"></div>
            </div>
            <div className="row">
              <div className="col">
                <div
                  className="savingsText modals doc"
                  style={{ marginBottom: "25px" }}
                >
                  Verify the customer information before sending the agreement
                </div>
              </div>
            </div>
            {state === "South Carolina" && (
              <>
                <div
                  style={{
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "1rem",
                    }}
                    onClick={() => setElectronicConsent(!electronicConsent)}
                  >
                    <div
                      className={
                        electronicConsent ? "checkBox checked" : "checkBox"
                      }
                    >
                      <img src={checkmark}></img>
                    </div>
                    <p>
                      By checking this box, the customer provides consent to
                      receive the Customer Installation Agreement
                      electronically.
                    </p>
                  </div>
                </div>
                {electronicConsent && (
                  <>
                    <h5>Customers Signature</h5>
                    <SignaturePad
                      onStartDrawing={() => setSigned(true)}
                      onClearDrawing={() => setSigned(false)}
                    />
                  </>
                )}
              </>
            )}
            <div
              className="row"
              style={
                state === "South Carolina" && (!electronicConsent || !signed)
                  ? {
                      opacity: 0.5,
                      pointerEvents: "none",
                      cursor: "not-allowed",
                    }
                  : {
                      opacity: 1,
                      pointerEvents: "auto",
                      cursor: "pointer",
                    }
              }
            >
              <div className="col-sm">{ciaButton()}</div>
              <div className="col"></div>
            </div>
            {utilityLocation === "Arizona" ? (
              <div className="row">
                <div className="col">
                  <a
                    href="https://vimeo.com/794231930/c1a0114347"
                    target="_blank"
                  >
                    <div className="costsText azCia">
                      {" "}
                      Arizona CIA information
                    </div>
                  </a>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default SendCIAMenu;
